import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20modern%20technology%20background%20with%20warm%20golden%20and%20amber%20gradient%20tones%2C%20geometric%20patterns%2C%20soft%20flowing%20curves%2C%20minimalist%20design%2C%20digital%20connection%20concept%2C%20clean%20and%20elegant%20composition%2C%20warm%20lighting%2C%20no%20text%2C%20no%20people%2C%20professional%20aesthetic&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="草榴二维码最新入口背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
          <div className="w-3 h-3 flex items-center justify-center">
            <i className="ri-sparkling-line text-xs text-primary-300"></i>
          </div>
          <span className="text-xs md:text-sm text-background-50/90 font-medium">
            2026年8月最新更新 · 所有入口已人工验证
          </span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
          {t('home.hero.title')}
        </h1>
        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          {t('home.hero.subtitle')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/latest-entry"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-qr-code-line"></i>
            </div>
            {t('home.hero.cta')}
          </Link>
          <Link
            to="/category/usage-tutorial"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 backdrop-blur-sm text-background-50 font-medium rounded-md border border-background-50/25 hover:bg-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-book-open-line"></i>
            </div>
            {t('home.hero.secondary')}
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <div className="w-8 h-12 flex items-start justify-center">
          <div className="w-5 h-8 rounded-full border-2 border-background-50/40 flex items-start justify-center p-1">
            <div className="w-1 h-2 rounded-full bg-background-50/60 animate-bounce"></div>
          </div>
        </div>
      </div>
    </section>
  );
}